module.exports = __webpack_public_path__ + "static/img/Opus_IVS_PoweredBy_Autotechcelerators_256.8ba85a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Opus_IVS_PoweredBy_Autotechcelerators_256.png
// module id = tZzz
// module chunks = 0